import { render, staticRenderFns } from "./AI.vue?vue&type=template&id=60127f41&scoped=true&"
import script from "./AI.vue?vue&type=script&lang=js&"
export * from "./AI.vue?vue&type=script&lang=js&"
import style0 from "./AI.vue?vue&type=style&index=0&id=60127f41&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60127f41",
  null
  
)

export default component.exports